import {
  CLIENTES_SET_CLIENTE_BEGIN,
  CLIENTES_SET_CLIENTE_SUCCESS,
  CLIENTES_SET_CLIENTE_FAILURE,
  CLIENTES_SET_CLIENTE_DISMISS_ERROR,
} from './constants';
import axios from 'axios'
import { getEndpoint } from '../../common/backend/endpoints'
import * as commonActions from '../../common/redux/actions'

const endpoint_clientes = getEndpoint('CLIENTES')


export function setCliente(cliente) {
  return (dispatch) => {
    dispatch({
      type: CLIENTES_SET_CLIENTE_BEGIN,
    });

    axios
    .put(endpoint_clientes + '/' + cliente.id, cliente)
    .then(() => {
      dispatch(
        commonActions.SuccessAction({
          title: 'Cliente modificado correctamente',
        }),
      );

      dispatch({
        type: CLIENTES_SET_CLIENTE_SUCCESS,
      });
    })
    .catch(err => {
      const dataError = err.response.data;
      dispatch({
        type: CLIENTES_SET_CLIENTE_FAILURE,
      });
      if (dataError.message.length > 0) {
        dataError.message.forEach(item => {
          dispatch(
            commonActions.WarningAction({
              title: item.msg,
            }),
          )
        })
      } else {
        dispatch(
          commonActions.ErrorAction({
            title: 'Error al modificar cliente',
          }),
        )
      }
    })
  }
}

export function dismissSetClienteError() {
  return {
    type: CLIENTES_SET_CLIENTE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case CLIENTES_SET_CLIENTE_BEGIN:
      return {
        ...state,
        guardadoClientePending: true,
        sameClient: false
      }
    case CLIENTES_SET_CLIENTE_SUCCESS:
      return {
        ...state,
        guardadoClientePending: false,
        updateClienteSuccess: true,
        sameClient: false
      }
    case CLIENTES_SET_CLIENTE_FAILURE: 
      return {
        ...state,
        guardadoClientePending: false,
        updateClienteError: action.data.dataError,
        sameClient: false
      }
    case CLIENTES_SET_CLIENTE_DISMISS_ERROR: 
      return {
        ...state,
        updateClienteError: null, 
        sameClient: false
      }

    default:
      return state
  }
}